module.exports = __webpack_public_path__ + "static/media/shubham.f4e578c4.jpeg";